import { INSTALL_VERIFY_TIMEOUT_MS } from '@mxa-argos/modules/forja/constants/forja.constants';
import type { ForjaApk } from '@mxa-argos/modules/forja/interfaces/forja-apk.interface';
import type { ForjaStep } from '@mxa-argos/modules/forja/interfaces/forja-step.interface';
import type { Semaphore } from '@mxa-argos/modules/forja/lib/semaphore';

export function installStepName(apk: ForjaApk): string {
  return `install ${apk.release.packageName}`;
}

export function installStep(apk: ForjaApk, installSlots: Semaphore): ForjaStep {
  const packageName = apk.release.packageName;

  return {
    name: installStepName(apk),
    verify: (device) => device.isPackageInstalled(packageName),
    apply: async (device) => {
      if (!installSlots.hasFreeSlot) {
        device.emit({
          type: 'install-progress',
          packageName,
          state: 'queued',
          transferredBytes: 0,
          totalBytes: apk.blob.size,
          bytesPerSecond: 0,
        });
      }

      await installSlots.acquire();

      try {
        await device.installApk(apk);
      } finally {
        installSlots.release();
      }
    },
    verifyTimeoutMs: INSTALL_VERIFY_TIMEOUT_MS,
    maxAttempts: 1,
  };
}
